import { useState, useRef } from 'react'

export function useToast() {
  const [toasts, setToasts] = useState([])
  const tid = useRef(0)

  const toast = (title, desc, kind) => {
    const id = ++tid.current
    setToasts((t) => [...t, { id, title, desc, kind }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3600)
  }

  const dismiss = (id) => setToasts((t) => t.filter((x) => x.id !== id))

  return { toasts, toast, dismiss }
}
